import { Route, Routes, useNavigate } from "react-router";
import AppBar from "../components/AppBar";
import { SlideIn } from "ft-shared-graphql";
import { Container, Fade } from "@mui/material";
import GlobalOverViewPage from "./GlobalOverViewPage";

const GlobalPageRoutes = () => {
    const navigate = useNavigate();
    const goBack = () => {
        navigate(-1);
    }
    return (
        <Routes>
            <Route path="*" element={<GlobalOverViewPage onBack={goBack} />} />
        </Routes>
    )
}

export const GlobalRoutes = () => {
    return (
        <>
            <AppBar />
            <SlideIn />
            <Fade appear in timeout={500}>
                <Container maxWidth="xl">
                    <GlobalPageRoutes />
                </Container>
            </Fade>
        </>
    )
}